import API from "@/api/forms2-4/FormOffersAPI";
import {idUserForApi} from "@/controllers/UserController";
import {spliceUslDataToArray} from "@/controllers/Organizations/Forms(2-4)/Form4AccreditationController";
import {FetchError} from "@/services/request";

class Form2OffersController {
  constructor() {
    this.api = API;
    this.mock = false
  }

  _checkId(id, text = 'id cannot be null') {
    if (!id)
      throw new Error(text);
  }

  /**
   *
   * @param { Number | null | undefined } [orgId]
   * */
  async getData(orgId) {
    try {
      orgId = orgId ?? idUserForApi(orgId);
      this._checkId(orgId);
      const res = this.mock ? {data: []} : await this.api.read(orgId);
      return spliceUslDataToArray(res.data);
    } catch (e) {
      console.error('error getData ' + e.message)
      throw new Error('error getData ' + e.message)
    }
  }

  async noAccreditationsCheck(orgId) {
    try {
      orgId = orgId ?? idUserForApi(orgId);
      this._checkId(orgId);
      const res = this.mock ? {data: []} : await this.api.noAccreditationsCheck(orgId);
      return res.data
    } catch (e) {
      console.error('error getData ' + e.message)
      throw new Error('error getData ' + e.message)
    }
  }

  /**
   *@param { {
   * id: number,
   * kcpUgs: {id: number},
   * sprOrgId: number,
   * qMinO: number,
   * qMinV: number,
   * qMinZ: number,
   * qMaxO: number,
   * qMaxV: number,
   * qMaxZ: number,
   * flApproved: boolean,
   * } } data
   * @param { Number | null | undefined } [orgId]
   * */
  async setData(data, orgId) {
    try {
      orgId = orgId ?? idUserForApi(orgId);
      this._checkId(orgId);
      const payload = {...data, orgId, fieldName: ['qMinO', 'qMinV', 'qMinZ', 'qMaxO', 'qMaxV', 'qMaxZ'].join(', ')};
      ['qMinO', 'qMinV', 'qMinZ', 'qMaxO', 'qMaxV', 'qMaxZ'].forEach(el => payload[el] = el ? Number.parseInt(payload[el]) : el)
      let res;
      if (data.id)
        res = this.mock ? {data: {...payload}} : await this.api.update(payload)
      else
        res = this.mock ? {data: {...payload, id: Math.random()}} : await this.api.create(payload);
      console.log('res', res)
      return res.data
    } catch (e) {
      console.error('error setData ' + e.message)
      throw new FetchError(e.response, e.body, e.message, e.status)
    }
  }

  /**
   *
   * @param { Number} [id]
   * */
  async deleteRow(id) {
    try {
      this._checkId(id);
      const res = this.mock ? {data: {}} : await this.api.delete(id);
      return res.data
    } catch (e) {
      console.error('error deleteRow ' + e.message)
      throw new Error('error deleteRow ' + e.message)
    }
  }

  /**
   * @param {number} kcpId
   * @param {number} [orgId]
   * */
  async getBlockAndMaxMinInfoByKcpId(kcpId, orgId) {
    try {
      orgId = orgId ?? idUserForApi(orgId);
      this._checkId(kcpId, 'KcpId cannot be null');
      this._checkId(orgId, 'orgId cannot be null');
      const requests = [await this.api.getBlockInfoForKcpGroup(kcpId), this.api.getMaxMinValuesInfoForKcpGroup(kcpId, orgId)];
      let response = {};
      await Promise.allSettled(requests).then(data => {
        response.blocks = data[0].value.data;
        response.minMaxValues = data[1].value.data;
      })
      return response
    } catch (e) {
      console.error('error getBlockAndMaxMinInfoByKcpId ' + e.message)
      throw new Error('error getBlockAndMaxMinInfoByKcpId ' + e.message)
    }
  }
}

export default new Form2OffersController()